import React, { useState } from 'react';
import { Row, Col, Input, Button, Label } from 'reactstrap';
import { AUDIT_MODULES, AUDIT_ACTIONS } from '../../../../services/audit_service';

// Converte os objetos CONSTANTES para arrays para exibir no select
const moduleOptions = Object.keys(AUDIT_MODULES).map(key => ({
    value: key, // O que salva no Firebase (usamos a string, então é AUDIT_MODULES[key] na verdade. Ops! Vamos usar o value)
    label: AUDIT_MODULES[key]
})).sort((a,b) => a.label.localeCompare(b.label));

const actionOptions = Object.keys(AUDIT_ACTIONS).map(key => ({
    value: AUDIT_ACTIONS[key],
    label: AUDIT_ACTIONS[key]
}));

const AuditFilters = ({ filters, onFilterSubmit, onClearFilters }) => {
    // Estado local para os inputs (só dispara a busca ao clicar em Filtrar)
    const [localFilters, setLocalFilters] = useState({ ...filters });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLocalFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleApply = () => {
        // Envia para o hook q reseta os cursores
        onFilterSubmit(localFilters);
    };

    const handleClear = () => {
        const cleared = { module: "", action: "", startDate: "", endDate: "", userId: "" };
        setLocalFilters(cleared);
        onClearFilters();
    };

    return (
        <React.Fragment>
            <div className="w-100 mb-3 bg-light p-3 border">
                        <Row className="g-2">
                            <Col xs={12} sm={6} md={3}>
                                <Label className="small font-weight-bold mb-1">Módulo</Label>
                                <Input
                                    type="select"
                                    name="module"
                                    value={localFilters.module}
                                    onChange={handleChange}
                                    className="form-select-sm"
                                >
                                    <option value="">Todos os Módulos</option>
                                    {moduleOptions.map(opt => (
                                        <option key={opt.value} value={opt.label}>{opt.label}</option>
                                    ))}
                                </Input>
                            </Col>

                            <Col xs={12} sm={6} md={2}>
                                <Label className="small font-weight-bold mb-1">Ação</Label>
                                <Input
                                    type="select"
                                    name="action"
                                    value={localFilters.action}
                                    onChange={handleChange}
                                    className="form-select-sm"
                                >
                                    <option value="">Todas</option>
                                    {actionOptions.map(opt => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </Input>
                            </Col>

                            <Col xs={12} sm={6} md={2}>
                                <Label className="small font-weight-bold mb-1">Data Início</Label>
                                <Input
                                    type="date"
                                    name="startDate"
                                    value={localFilters.startDate}
                                    onChange={handleChange}
                                    className="form-control-sm"
                                />
                            </Col>

                            <Col xs={12} sm={6} md={2}>
                                <Label className="small font-weight-bold mb-1">Data Fim</Label>
                                <Input
                                    type="date"
                                    name="endDate"
                                    value={localFilters.endDate}
                                    onChange={handleChange}
                                    className="form-control-sm"
                                />
                            </Col>

                            <Col xs={12} md={3} className="d-flex align-items-end justify-content-end mt-2 mt-md-0 gap-2">
                                <Button color="secondary" size="sm" outline onClick={handleClear}>
                                    <i className="mdi mdi-filter-remove-outline me-1"></i> Limpar
                                </Button>
                                <Button color="primary" size="sm" onClick={handleApply}>
                                    <i className="mdi mdi-filter me-1"></i> Filtrar
                                </Button>
                            </Col>
                        </Row>
            </div>
        </React.Fragment>
    );
};

export default AuditFilters;
